import React from "react";

import {
  Box,
  createSvgIcon,
  Grid,
  InputAdornment,
  Skeleton,
  styled,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Notifications from "./Notifications";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import NotificationBox from "../../Header/NotificationBox";
import useMobile from "../../../hooks/useMobile";
import { Search } from "@mui/icons-material";
import { create } from "@mui/material/styles/createTransitions";
import ThemeToggle from "./ThemeToggle";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  background: "#161D26",
  padding: "15px",
  paddingLeft: "80px",
  zIndex: 200,
  paddingBottom: 0,
  border: "none",
  boxShadow: "none",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ".MuiToolbar-root": {
    paddingLeft: "2rem",
  },
  ...(open && {
    zIndex: "9 !important",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const MiniLogoIcon = createSvgIcon(
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.835 0C14.8661 0.0191651 14.9043 0.0287476 14.921 0.052704C14.9784 0.138947 15.0285 0.232377 15.0787 0.321015C18.8326 6.94495 22.5866 13.5665 26.3405 20.188C27.2031 21.7093 28.0657 23.2305 28.9283 24.7541C28.9857 24.8547 29.0382 24.9577 29.0932 25.0607C29.1147 25.1015 29.0812 25.1638 29.0406 25.1686C29.0072 25.1733 28.9713 25.1829 28.9379 25.1829C28.8447 25.1853 28.7539 25.1853 28.6607 25.1853C25.1648 25.1853 21.6714 25.1853 18.1755 25.1853C18.0608 25.1853 17.9437 25.1805 17.829 25.1757C17.7669 25.1733 17.7382 25.1087 17.7693 25.0488C17.786 25.0176 17.8004 24.9865 17.8171 24.9553C17.8792 24.8451 17.9437 24.7325 18.0059 24.6223C18.5363 23.6857 19.0692 22.749 19.5997 21.8099C19.6403 21.7404 19.6809 21.6685 19.7215 21.5991C19.7645 21.5224 19.8243 21.4793 19.9175 21.4793C20.0226 21.4817 20.1254 21.4769 20.2305 21.4769C20.9712 21.4769 21.712 21.4769 22.4527 21.4769C22.5435 21.4769 22.6367 21.4649 22.7275 21.4529C22.7419 21.4505 22.7586 21.4218 22.761 21.4002C22.7634 21.3787 22.7586 21.3547 22.749 21.3355C22.706 21.2541 22.663 21.1702 22.6176 21.0912C20.1206 16.6856 17.6235 12.2824 15.1265 7.87685C15.0644 7.76665 14.9999 7.65645 14.933 7.54625C14.8876 7.47199 14.8207 7.47438 14.7729 7.55584C14.7131 7.65406 14.6534 7.75467 14.5984 7.85529C13.3296 10.0928 12.0608 12.3303 10.7919 14.5679C10.7346 14.6685 10.6701 14.7643 10.6103 14.8625C10.5936 14.8889 10.541 14.8817 10.5219 14.8529C10.4837 14.7954 10.4455 14.738 10.412 14.6781C9.80508 13.6096 9.20053 12.5412 8.5936 11.4727C8.56492 11.4224 8.53625 11.3721 8.50996 11.3194C8.47412 11.2523 8.4789 11.1852 8.51474 11.1205C8.55775 11.0391 8.60315 10.9576 8.64855 10.8762C9.53984 9.30465 10.4311 7.73311 11.3224 6.15918C12.4192 4.22351 13.516 2.28783 14.6128 0.354554C14.6821 0.239564 14.7394 0.112595 14.835 0Z"
      fill="#04D9FF"
    />
    <path
      d="M16.9446 18.7958C16.9398 18.8173 16.9374 18.8437 16.9279 18.8629C16.892 18.9347 16.8514 19.0066 16.8132 19.0761C14.8084 22.6144 12.8012 26.1528 10.794 29.6887C10.7367 29.7894 10.6722 29.8852 10.61 29.981C10.5933 30.0074 10.5383 30.005 10.5192 29.9786C10.4643 29.89 10.4069 29.8037 10.3543 29.7127C9.79998 28.7353 9.24561 27.7579 8.69125 26.7804C7.94811 25.47 7.20497 24.1596 6.45945 22.8516C6.41166 22.7677 6.38776 22.6528 6.27068 22.624C6.1751 22.6623 6.1512 22.7606 6.1058 22.8396C5.73782 23.484 5.37222 24.1285 5.00663 24.7729C4.97795 24.8232 4.94928 24.8735 4.9206 24.9238C4.77245 25.1825 4.7844 25.1849 4.49049 25.1849C3.27423 25.1849 2.06036 25.1849 0.844103 25.1849C0.798702 25.1849 0.750912 25.1825 0.705511 25.1802C0.61232 25.1754 0.576478 25.1227 0.61471 25.0484C0.6625 24.9574 0.71268 24.8639 0.765249 24.7753C1.58724 23.3235 2.40923 21.8718 3.23361 20.42C4.17747 18.7575 5.11893 17.0949 6.06279 15.4323C6.12014 15.3317 6.18465 15.2359 6.24917 15.14C6.25634 15.1305 6.29935 15.1305 6.30652 15.14C6.35909 15.2143 6.41166 15.291 6.45706 15.3724C6.92062 16.1893 7.38419 17.0038 7.84536 17.8208C8.6793 19.2917 9.51324 20.765 10.352 22.2335C10.4117 22.3365 10.4284 22.4827 10.579 22.5186C10.6889 22.4587 10.7199 22.3389 10.7749 22.2431C12.0342 20.0271 13.2911 17.8088 14.5479 15.5904C14.6172 15.4706 14.6841 15.3485 14.7534 15.2263C14.8275 15.0993 14.8729 15.0969 14.9446 15.2167C14.9685 15.2574 14.9924 15.2958 15.0139 15.3365C15.6137 16.3954 16.2134 17.4518 16.8132 18.5107C16.8538 18.5802 16.892 18.652 16.9279 18.7239C16.9422 18.7479 16.9422 18.7742 16.9446 18.7958Z"
      fill="#04D9FF"
    />
  </svg>
);

const SettingsIcon = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="2 2 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0652 3.01861C13.6466 2.69562 14.3535 2.69562 14.9349 3.01861L23.3349 7.68528C23.946 8.02479 24.3251 8.66894 24.3251 9.36803V18.6324C24.3251 19.3315 23.946 19.9756 23.3349 20.3151L14.9349 24.9818C14.3535 25.3048 13.6466 25.3048 13.0652 24.9818L4.66519 20.3151C4.05406 19.9756 3.67505 19.3315 3.67505 18.6324V9.36803C3.67505 8.66894 4.05407 8.02479 4.66519 7.68528L13.0652 3.01861ZM14.085 4.54839C14.0322 4.51903 13.9679 4.51903 13.9151 4.54839L5.51506 9.21506C5.4595 9.24592 5.42505 9.30448 5.42505 9.36803V18.6324C5.42505 18.6959 5.4595 18.7545 5.51506 18.7854L13.9151 23.452C13.9679 23.4814 14.0322 23.4814 14.085 23.452L22.485 18.7854C22.5406 18.7545 22.5751 18.6959 22.5751 18.6324V9.36803C22.5751 9.30448 22.5406 9.24592 22.485 9.21506L14.085 4.54839Z"
      fill="white"
      stroke="2px"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.45838 14.0002C8.45838 10.9396 10.9395 8.45854 14 8.45854C17.0606 8.45854 19.5417 10.9396 19.5417 14.0002C19.5417 17.0608 17.0606 19.5419 14 19.5419C10.9395 19.5419 8.45838 17.0608 8.45838 14.0002ZM14 10.2085C11.906 10.2085 10.2084 11.9061 10.2084 14.0002C10.2084 16.0943 11.906 17.7919 14 17.7919C16.0941 17.7919 17.7917 16.0943 17.7917 14.0002C17.7917 11.9061 16.0941 10.2085 14 10.2085Z"
      fill="white"
      stroke="2px"
    />
  </svg>
);

const DownArrow = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2853 10.4643C19.627 10.806 19.627 11.36 19.2853 11.7017L14.6186 16.3684C14.2769 16.7101 13.7229 16.7101 13.3812 16.3684L8.71453 11.7017C8.37282 11.36 8.37282 10.806 8.71453 10.4643C9.05624 10.1226 9.61026 10.1226 9.95197 10.4643L13.9999 14.5122L18.0479 10.4643C18.3896 10.1226 18.9436 10.1226 19.2853 10.4643Z"
      fill="white"
    />
  </svg>
);

const HamburgerIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H5C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.75 7C19.75 6.58579 19.4142 6.25 19 6.25H5C4.58579 6.25 4.25 6.58579 4.25 7C4.25 7.41421 4.58579 7.75 5 7.75H19C19.4142 7.75 19.75 7.41421 19.75 7Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.75 17C19.75 16.5858 19.4142 16.25 19 16.25H5C4.58579 16.25 4.25 16.5858 4.25 17C4.25 17.4142 4.58579 17.75 5 17.75H19C19.4142 17.75 19.75 17.4142 19.75 17Z"
      fill="white"
    />
  </svg>
);

const Header = ({ open, headerTitle, handleDrawerOpen }) => {
  const user_profile = useSelector((state) => state.user);
  const { theme } = useSelector((state) => state.theme);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMobile = useMobile();
  const openProfile = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="absolute"
      open={open}
      className="header-st"
      sx={{ paddingLeft: isMobile ? 0 : "80px" }}
    >
      <Toolbar className="header-Toolbar">
        {/* <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                marginRight: 5,
                ...(open && { display: 'none' }),
                }}
            >
                <MenuIcon />
            </IconButton> */}
        <Grid container className="header-Container">
          <Grid
            item
            xs={4}
            textAlign="left"
            display={"flex"}
            className="header-Logo"
          >
            {isMobile ? (
              <>
                <MiniLogoIcon
                  sx={{ width: "45px", height: "45px" }}
                  viewBox="0 0 30 30"
                />
                <Typography
                  noWrap
                  component={"h1"}
                  fontSize={"1.5rem"}
                  fontWeight="bold"
                  textAlign="left"
                  sx={{ padding: "0 1rem" }}
                >
                  {headerTitle}
                </Typography>
              </>
            ) : (
              <Typography
                variant="h6"
                noWrap
                component="div"
                fontSize={"2rem"}
                fontStyle={"normal"}
                lineHeight="140%"
                fontWeight={"700"}
              >
                {headerTitle}
              </Typography>
            )}
          </Grid>
          {/* {headerTitle === "Achievements" ? (
            <Grid item xs>
              <div className="Search-Box">
                <TextField
                  id="search"
                  name="search"
                  type="text"
                  placeholder="Search"
                  className={`Header-Search ${
                    theme === "light" ? "Header-Light" : ""
                  }`}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Grid>
          ) : (
            <></>
          )} */}
          <Grid
            className="header-icons-wrapper"
            container
            item
            xs
            display="flex"
            columnSpacing={2}
            justifyContent={"flex-end"}
            alignItems="center"
            sx={{ gap: "1rem" }}
          >
            {/* <Notifications /> */}
            <ThemeToggle />

            {isMobile ? (
              false
            ) : (
              <Link to="/profile" className="setting-icon">
                <SettingsIcon />
              </Link>
            )}
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={openProfile}
              onClose={handleClose}
              // onClick={handleClose}
            >
              <NotificationBox onEditclick={null}/>
            </Menu>
            {isMobile ? (
              <div className="menu-icon">
                <HamburgerIcon onClick={handleDrawerOpen} />
              </div>
            ) : (
              false
            )}
            <Box
              onClick={handleClick}
              display={"flex"}
              justifyContent="flex-end"
              alignItems={"center"}
              gap="1rem"
              sx={{ cursor: "pointer" }}
              className="notification-icons"
            >
              <Grid
                item
                xs={3}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                {user_profile && user_profile.photo ? (
                  <img
                    src={user_profile.photo}
                    alt="Profile"
                    width={40}
                    height={40}
                    style={{ borderRadius: "50%" }}
                  />
                ) : (
                  <Skeleton
                    sx={{ bgcolor: "#222c3a" }}
                    animation={!Object.keys(user_profile).length && true}
                    variant="circular"
                    width={40}
                    height={40}
                  />
                )}
              </Grid>
              {isMobile ? (
                <DownArrow />
              ) : (
                <Grid
                  item
                  xs={9}
                  display="flex"
                  justifyContent="center"
                  alignItems="flex-start"
                  flexDirection="row"
                >
                  <div sx={{ display: "flex" }}>
                    {user_profile && user_profile.full_name ? (
                      <Typography
                        className="profile-name"
                        noWrap
                        component="div"
                      >
                        {user_profile.full_name}
                      </Typography>
                    ) : (
                      <Skeleton
                        sx={{ bgcolor: "#222c3a" }}
                        animation={!Object.keys(user_profile).length && true}
                        variant="text"
                      />
                    )}
                    <div className="profile-acc">
                      {user_profile && user_profile.current_account}
                    </div>
                  </div>
                  <div className="arrow">
                    {" "}
                    <DownArrow />
                  </div>
                </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
